<div style="display: block;">
  <canvas baseChart
          [datasets]="barChartData"
          [options]="barChartOptions"
          [labels]="barChartLabels"
          [plugins]="[ChartDataLabels]"
          [legend]="showLegend"
          [type]="'bar'">
  </canvas>
</div>
